<template>
    <v-layout justify-center>
        <v-dialog v-model="show" max-width="1000px">
            <v-card>
                <v-card-title class="pa-0 ma-0">
                    <v-toolbar dark color="blue lighten-2" class="titlebar">
                        <v-btn icon dark @click="show = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>
                            <span class="headline">Тарифы</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                </v-card-title>
                <v-card-text class="content">
                    <v-container class="container-main mx-0 px-0" fluid>
                        <v-row>
                            <v-col cols="7" class="mx-0 px-0">
                                <p>Ваш тариф: <b>{{tariff ? tariff.title : ''}}</b></p>
                                <p>Стоимость ₽/месяц: {{tariff ? tariff.value : ''}}</p>
                                <p>Максимальное количество товаров: {{tariff ? tariff.max_count_items : ''}}</p>
                                <p v-show="tariff ? tariff.id != 8 : false">Тариф оплачен до: {{payedTo ? payedTo : ''}}</p>
                                <p class="font-weight-bold">Для изменения тарифа напишите <a target="_blank" href="https://t.me/denzlbro">@denzlbro</a></p>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col v-for="tariff in tariffDescriptions"
                                   :key="tariff.id + 'd'" ><p class="font-weight-bold">{{tariff.title}}</p><span v-html="tariff.description"></span></v-col>
                        </v-row>
                        <v-card hover>
                        <v-row class="ml-2">
                            <v-col><span class="font-weight-bold">Название</span></v-col>
                            <v-divider vertical/>
                            <v-col><span class="font-weight-bold">Стоимость в месяц</span></v-col>
                            <v-divider vertical/>
                            <v-col><span class="font-weight-bold">Количество месяцев</span></v-col>
                        </v-row>
                        </v-card>
                        <v-card hover elevation-2
                                v-for="tariff in tariffsByStyle"
                                :key="tariff.id"
                                >
                            <v-row
                                    class="ml-2 mt-1"
                            >
                                <v-col>{{tariff.title}}</v-col>
                                <v-divider vertical/>
                                <v-col>{{tariff.value}} ₽</v-col>
                                <v-divider vertical/>
                                <v-col>{{tariff.duration}}</v-col>
                            </v-row>

                        </v-card>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import timeHelpers from '../../../scripts/helpers/timeHelpers'

export default {
    name: 'TariffForm',
    data() {
        return {
            show: false,
            botModel: { id: null },
            selectedMenu: 0,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            valid: false
        }
    },
    props: ['dialog'],
    watch: {
        dialog: {
            handler(value) {
                this.show = value
            },
            immediate: true
        },
        show(value) {
            if (value === false) {
                this.$emit('close')
            }
        }
    },
    computed: {
        ...mapGetters({
            tariffs: 'bots/tariffs',
            getTariffById: 'bots/getTariffById',
            getBotById: 'bots/getBotById'
        }),
        bot() {
            let botId = this.$route.params['pathMatch']
            return this.getBotById(+botId)
        },
        tariff() {
            let botId = this.$route.params['pathMatch']
            let bot = this.getBotById(+botId)
            return bot ? this.getTariffById(bot.tariff_id) : null
        },
        payedTo() {
            let botId = this.$route.params['pathMatch']
            let bot = this.getBotById(+botId)
            return bot ? timeHelpers.getDateOutUnixTime(bot.paid_to) + ' ' + timeHelpers.getTimeOutUnixTime(bot.paid_to) : 0
        },
        tariffDescriptions() {
            if (this.bot) {
                let tariffs = this.tariffs.filter(tariff => tariff.description && tariff.bot_style === this.bot.style)
                tariffs = this._.orderBy(tariffs, ['value'], ['asc'])
                return tariffs
            }
            return []
        },
        tariffsByStyle() {
            if (this.bot) {
                return this.tariffs.filter(tariff => tariff.bot_style === this.bot.style)
            }
            return []
        }
    },
    methods: {
        // ...timeHelpers
    }
}
</script>

<style scoped>

</style>
